import type { BacklogEntityMetadata as BacklogEntityMetadataContract } from "../../contracts/utils/metadata/BacklogEntityMetadata";
import type { MetaTypeKey } from "../../contracts/utils/metadata/MetaTypeKey";
import type { MetadataTypeInfo } from "../../contracts/utils/metadata/MetadataTypeInfo";

export class BacklogEntityMetadata<T>
	implements BacklogEntityMetadataContract<T>
{
	constructor(
		private readonly key: MetaTypeKey<T>,
		private readonly type_name: string,
		private readonly type_info_list: MetadataTypeInfo<T>[],
	) {}

	isArrayType(): boolean {
		return this.key.isArrayType();
	}

	isUnionType(): boolean {
		return 2 <= this.type_info_list.length;
	}

	getPath(): string {
		return this.key.getMetaDataPath();
	}

	getTypeName(): string {
		return this.type_name;
	}

	validate(value: unknown, options?: { strict: boolean }): boolean {
		if (this.isArrayType()) {
			if (options?.strict && !Array.isArray(value)) {
				return false;
			}
			if (Array.isArray(value)) {
				for (const d of value) {
					if (!this.matchType(d, options)) {
						return false;
					}
				}
				return true;
			}
		}
		return this.matchType(value, options);
	}

	matchType(value: unknown, options?: { strict: boolean }): boolean {
		for (const type_info of this.type_info_list) {
			if (type_info.matchType(value, options)) {
				return true;
			}
		}
		return false;
	}

	getTypeInfo(
		value: unknown,
		options?: { strict: boolean },
	): MetadataTypeInfo<T>[] {
		return this.type_info_list.filter((v) => v.matchType(value, options));
	}

	getAllTypeInfo(): MetadataTypeInfo<T>[] {
		return [...this.type_info_list];
	}
}
